<app-header></app-header>
<div class="row summary">
  <div class="col-md-12">
    <div class="title"
         *ngIf="manualInvestType == 'hybrid_invest' && areSelectedInvestmentsAvailable()">
      <p> Good Choice! </p>
      {{getSubtitleText()}} will ensure that we pick the best suited loans for your pending investment amount.
      Your current weighted average return is <span class="roi">{{expectedRoi | number : '1.2-2'}} %</span>
      <app-rate-of-return-tooltip placement="bottom"></app-rate-of-return-tooltip>
    </div>

    <div class="title"
         *ngIf="manualInvestType == 'auto_invest' && !areSelectedInvestmentsAvailable()">
      <p> Good Choice! </p>
      We will ensure that we pick the best suited loans for your investment amount through
      <span class="preference-type"> {{getSubtitleText()}} </span>
    </div>

    <div class="portfolio-information">
      <div class="row" *ngIf="areSelectedInvestmentsAvailable()">
            <div class="col-md-4 col-md-offset-4 col-xs-12 text-center">
              <app-doughnut [dataSet]="chartData" [centerText]="'ROI: ' + expectedRoi + '%'"></app-doughnut>
            </div>
      </div>
      <div class="finzy-portfolio-container">
        <app-manual-invest-investment-title color="#4a4a4a" editColor="#0d3ab3" editTextColor="#4a4a4a"
                                            *ngIf="!areSelectedInvestmentsAvailable()"
                                            (titleChangedEvent)="onTitleChanged($event)"></app-manual-invest-investment-title>
        <p class="finzy-portfolio-title" *ngIf="areSelectedInvestmentsAvailable()">{{manualInvestTitle}}</p>
        <p class="finzy-portfolio-date">({{manualInvestType}})</p>
        <p class="finzy-portfolio-investment" *ngIf="areSelectedInvestmentsAvailable()">INVESTMENT</p>
        <p class="finzy-portfolio-investment-amount">₹ {{manualInvestAmount | number : fractionSize}}</p>
        <p class="finzy-portfolio-pending-amount" *ngIf="!areSelectedInvestmentsAvailable()">Amount pending to be auto
          invested</p>
      </div>
    </div>

    <div class="col-md-12 finzy-margin-20" *ngIf="manualInvestType == 'hybrid_invest' || 'auto_invest'">
      <div class="col-md-3"></div>
      <div class="col-md-3 finzy-center finzy-padding-0 finzy-center-amount" *ngIf="areSelectedInvestmentsAvailable()">
        <p class="finzy-invesment-amount">
          ₹ {{(manualInvestAmount - manualInvestRemainingAmount) | number : fractionSize}}
        </p>
        <p class="finzy-invesment-amount-sub">
          Amount already manually invested
        </p>
      </div>
      <div class="col-md-3 finzy-center finzy-padding-0 finzy-center-amount" *ngIf="areSelectedInvestmentsAvailable()">
        <p class="finzy-invesment-amount">
          ₹ {{ manualInvestRemainingAmount | number : fractionSize}}
        </p>
        <p class="finzy-invesment-amount-sub">
          Amount pending to be auto invested
        </p>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-12 content">
        <div class="col-md-12">
          <div class="finzy-partial-invest-p">
            <p *ngIf="!hasUserChosenPreferences()" class="padded-content">{{getContent()}}</p>
            <div *ngIf="hasUserChosenPreferences()">
              <p class="padded-content">{{getContent()}}</p>
                <app-selected-preferences
                        [preferredCategories]="manualInvestmentPortfolioCreationData.portfolioPreference">
                </app-selected-preferences>
            </div>
        </div>
    </div>
  </div>
  <div class="col-md-12 manual-table">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div class="mt-5 d-flex justify-content-between" style="padding-bottom: 20px;">
        <button mat-stroked-button type="button" class="primary" (click)="goBack()">
          BACK
        </button>

        <div class="text-right">
          <button *ngIf="hideConfirmPortfolio" mat-flat-button class="primary" type="button" (click)="confirmPortfolio()">COMPLETE INVESTMENT
          </button>

          <div class="loader" *ngIf="loader">
            <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
          </div>

          <p *ngIf="manualInvestSummaryError"
             class="bottom finzy-float finzy-error finzy-mar-top10 finzy-mar-right10">
            {{manualInvestSummaryErrorMsg}}</p>

        </div>

      </div>
      <mat-table #table [dataSource]="dataSource" *ngIf="areSelectedInvestmentsAvailable()" matSort>
        <ng-container matColumnDef="roi">
          <mat-header-cell *matHeaderCellDef mat-sort-header> ROI %</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.roi | number : '1.2-2'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="city">
          <mat-header-cell *matHeaderCellDef mat-sort-header> LOCATION</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.correspondence_address.city}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="rating">
          <mat-header-cell *matHeaderCellDef mat-sort-header> RATING</mat-header-cell>
          <mat-cell *matCellDef="let element">  {{element.rating }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef mat-sort-header> INVESTMENT</mat-header-cell>
          <mat-cell *matCellDef="let element"> ₹ {{element.amount | number : fractionSize}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="filled_percentage">
          <mat-header-cell *matHeaderCellDef mat-sort-header> FILLED %</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.filled_percentage | number : '1.2-2' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="loan_reason">
          <mat-header-cell *matHeaderCellDef mat-sort-header> REASON</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.loan_reason}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <mat-paginator #paginator [length]="10" [pageSize]="10"
                     [pageSizeOptions]="[10, 20, 30]" *ngIf="areSelectedInvestmentsAvailable()">
      </mat-paginator>
      <div class="row buttondiv mt-5" *ngIf="areSelectedInvestmentsAvailable()">
        <div class="col-sm-3">
          <button mat-stroked-button class="primary" type="button" (click)="goBack()">
            BACK
          </button>
        </div>
        <div class="col-sm-6 finzy-float col-sm-offset-3">
          <button *ngIf="hideConfirmPortfolio" mat-flat-button class="primary" type="button" (click)="confirmPortfolio()">COMPLETE INVESTMENT
          </button>

          <div class="loader" *ngIf="loader">
            <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
          </div>
          <p *ngIf="manualInvestSummaryError"
             class="bottom finzy-float finzy-error finzy-mar-top10 finzy-mar-right10">
            {{manualInvestSummaryErrorMsg}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
